/**
 * Volume — the bar's raw share volume, surfaced as an addable scanner/watchlist
 * column. No parameters: it just lifts `data.volumes` into the shared-indicator
 * contract so the "+ Indicator" picker, the compute route, and the chart all
 * resolve it the same way every other def does.
 *
 * The scanner takes the last finite value — i.e. the last COMPLETED session's
 * volume off-hours (the dynamic compute path drops the forming bar), and the
 * live cumulative session volume during regular trading hours. Rendered with
 * the "compact" format (K/M/B), e.g. 1,234,567 -> "1.2M".
 */
import { familyGroup } from "./indicatorGroups";
import type { OHLCV, IndicatorParams, SharedIndicatorDef } from "./types";

export const VOLUME: SharedIndicatorDef = {
  id: "volume",
  label: "Volume",
  group: familyGroup("rvol"), // "Force / Volume"
  format: "compact",
  params: [],
  computeSeries(data: OHLCV, _params: IndicatorParams): (number | null)[] {
    const { volumes } = data;
    return volumes.map((v) => (Number.isFinite(v) ? v : null));
  },
};
